import { createSlice } from "@reduxjs/toolkit";

const initialorganizationCategoryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  organizationCategoryForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminOrganizationCategorySlice = createSlice({
  name: "organizationCategory",
  initialState: initialorganizationCategoryState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getorganizationCategoryById
    organizationCategoryFetched: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.organizationCategoryForEdit = action.payload.data;
    },
    // findorganizationCategory
    organizationCategorysFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    organizationCategoryReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    organizationCategoryFiles: (state, action) => {
      state.organizationCategoryFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    organizationCategoryFilesFetched: (state, action) => {
      state.organizationCategoryFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
